import apiClient from '@/plugins/axios';

export default {
	getRoundHistoryItems(searchParam) {
		const langCode = localStorage.getItem('lang') || 'sv';

		let query = `?PageNumber=${searchParam.currentPage}&PageSize=${searchParam.pageSize}`;
		query += searchParam.roundHistoryId
			? `&RoundHistoryId=${searchParam.roundHistoryId}`
			: '';
		query += searchParam.orderBy ? `&OrderBy=${searchParam.orderBy}` : '';
		query += `&langCode=${langCode}`;

		return apiClient.get(`v1/RoundHistoryItem${query}`);
	},

	getRoundHistoryItem(roundHistoryItemId) {
		const langCode = localStorage.getItem('lang') || 'sv';
		return apiClient.get(`v1/RoundHistoryItem/${roundHistoryItemId}`, {
			params: { langCode }
		});
	},


	createRoundHistoryItem(roundHistoryItem) {
		return apiClient.post('v1/RoundHistoryItem', roundHistoryItem);
	},

	updateRoundHistoryItem(roundHistoryItem) {
		var roundHistoryItemId = roundHistoryItem.id;

		return apiClient.put(
			`v1/RoundHistoryItem/${roundHistoryItemId}`,
			roundHistoryItem
		);
	},

	deleteRoundHistoryItem(roundHistoryItemId) {
		return apiClient.delete(`v1/RoundHistoryItem/${roundHistoryItemId}`);
	}
};
